import { FC, PropsWithChildren } from "react";
import styles from "./Table.module.scss";

const TableHeader: FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className={styles.tableTop}>
            <h2 className={styles.tableTitle}>
                <span>List of projects</span>
            </h2>
            <div className={styles.control}>{children} </div>
        </div>
    );
};

export default TableHeader;
